import { useCallback, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ArrowRightFromSquare, ChartAreaStacked, Gear, Person, SquareListUl, CircleInfoFill } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';
import { useNavigateReplace } from 'hooks';
import { useAppDispatch } from 'store/hooks/use-app';
import { logout } from 'store/slices/user-slice';
import { routes } from 'routes';
import { Divider } from '../../ui-kit';
import { ModalOut } from '../../ui-kit/modal-log-out';

import { ADMIN, ADMIN_MODE, ANALYTICS, LIST, OUT_ADMIN_PANEL, PROFILE } from './constants';

import styles from './styles.module.scss';

export const Navigation = ({ role, isAdminMode, setIsAdminMode, isAdaptive }: any) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigateReplace();
	const [open, setOpen] = useState(false);

	const buttonSize = isAdaptive ? 'm' : 'l';

	const iconSize = isAdaptive ? 13 : 16;

	const handleLogOut = useCallback(() => {
		dispatch(logout());
		navigate(routes.login.path);
	}, [dispatch, navigate]);

	return (
		<>
			{role === 'ADMIN' && isAdminMode ? (
				<nav className={styles.navigation}>
					<div className={styles.navigation__notification}>
						<Icon data={CircleInfoFill} size={16} />
						{ADMIN_MODE}
					</div>

					<NavLink to="/">
						<Button size={buttonSize} view="outlined" onClick={() => setIsAdminMode(false)}>
							<Icon data={ArrowRightFromSquare} size={16} />
							{OUT_ADMIN_PANEL}
						</Button>
					</NavLink>
				</nav>
			) : (
				<nav className={styles.navigation}>
					<div className={styles.navigation__pages}>
						<NavLink to="profile" className={styles.profile}>
							{({ isActive }) => (
								<Button
									className={
										isActive
											? `${styles.navigation__button} ${styles.active}`
											: styles.navigation__button
									}
									size={buttonSize}
								>
									<Icon data={Person} size={16} />
									{PROFILE}
								</Button>
							)}
						</NavLink>

						<NavLink to="/">
							{({ isActive }) => (
								<Button
									className={
										isActive
											? `${styles.navigation__button} ${styles.active}`
											: styles.navigation__button
									}
									view="normal"
									size={buttonSize}
								>
									<Icon data={SquareListUl} size={iconSize} />
									{LIST}
								</Button>
							)}
						</NavLink>

						<NavLink to="/charts">
							{({ isActive }) => (
								<Button
									className={
										isActive
											? `${styles.navigation__button} ${styles.active}`
											: styles.navigation__button
									}
									view="normal"
									size={buttonSize}
								>
									<Icon data={ChartAreaStacked} size={iconSize} />
									{ANALYTICS}
								</Button>
							)}
						</NavLink>
					</div>

					<div className={styles.navigation__admin}>
						{role === 'ADMIN' ? (
							<NavLink to="admin" onClick={() => setIsAdminMode(true)}>
								{({ isActive }) => (
									<Button
										className={
											isActive
												? `${styles.navigation__button} ${styles.active}`
												: styles.navigation__button
										}
										view="outlined"
										size={buttonSize}
										// selected={!!isActive}
									>
										<Icon data={Gear} size={16} />
										{ADMIN}
									</Button>
								)}
							</NavLink>
						) : (
							<Button className={styles.navigation__button} view="outlined" size={buttonSize} disabled>
								<Icon data={Gear} size={iconSize} />
								{ADMIN}
							</Button>
						)}

						<Divider />

						<Button
							className={styles.navigation__button}
							view="flat"
							size={buttonSize}
							onClick={() => setOpen(true)}
						>
							<Icon data={ArrowRightFromSquare} size={iconSize} />
						</Button>
						<ModalOut open={open} setOpen={setOpen} handleLogOut={handleLogOut} />
					</div>
				</nav>
			)}
		</>
	);
};
